import React from "react";

import ErrorComponent from "./ErrorComponent";

const ErrorFallbackComponent = ({ error, componentStack, resetErrorBoundary, ...rest }) => {
  return (
    <ErrorComponent error={error} componentStack={componentStack} resetErrorBoundary={resetErrorBoundary} {...rest} />
  );
};

export default ErrorFallbackComponent;
